'use strict'
import { plainToClass } from 'class-transformer'
import Response from '@/utils/response'
import User from '@/models/user'
import pageLoading from '@/mixins/page-loading'
import pageTitle from '@/mixins/page-title'
import BtnIcon from '@/components/button/BtnIcon'
import DialogUpdatePassword from '@/components/dialog/DialogUpdatePassword'
import IconWith from '@/components/icon/IconWith'

export default {
  components: {
    BtnIcon,
    DialogUpdatePassword,
    IconWith,
  },
  mixins: [
    pageLoading,
    pageTitle,
  ],
  title () {
    return this.$t("pages.user.user.show.title")
  },
  props: {
    repository: Object
  },
  data: () => ({
    user: new User(),
    passwordDialog: false,
    passwordValidationError: ""
  }),
  mounted () {
    this.fetchData()
  },
  methods: {
    async fetchData () {
      if (this.loading) return
      this.loading = true
      try {
        const response = new Response(await this.repository.get())
        this.user = plainToClass(User, response.result)
      } catch (error) {
        this.$store.commit('setAxiosError', error)
      } finally {
        this.loading = false
      }
    },
    async updatePassword (params) {
      try {
        const response = new Response(await this.repository.updatePassword(params))
        if (response.success) {
          this.$store.commit('setSnackbar', response.snackbarParams)
          this.passwordDialog = false
        } else {
          this.passwordValidationError = response.errorMessage
        }
      } catch (error) {
        this.$store.commit('setAxiosError', error)
      }
    }
  }
}
